import { render, staticRenderFns } from "./DefaultParties.vue?vue&type=template&id=8cb64aa0&"
import script from "./DefaultParties.vue?vue&type=script&lang=js&"
export * from "./DefaultParties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports